import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getTeacherAnalytics = async (query?: string) => {
  return serviceHelper(http.get(`/teacher/analytics?${query}`), false);
};

export const exportTeacherAnalytics = async (
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(
      `/teacher/analytics/export${queryString ? '?' + queryString : ''}`,
      {
        responseType: 'blob',
      }
    ),
    false
  );
};

export const getParentAnalyticsGames = async (query?: string) => {
  return serviceHelper(http.get(`/parent/analytics/games?${query}`), false);
};

export const getParentAnalyticsGamesDropdown = async () => {
  return serviceHelper(http.get('/parent/analytics/games-dropdown'), false);
};

export const exportParentAnalytics = async (
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/parent/analytics/export?${queryString}`, {
      responseType: 'blob',
    }),
    false
  );
};
